import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import BookInfo from "features/books/components/BookInfo";
import BookLayout from "features/books/layouts/BookLayout/BookLayout";

function Show() {
  return (
    <BookLayout>
      <BookInfo />
    </BookLayout>
  );
}

Show.layout = DefaultLayoutWrapper;
export default Show;